module.exports = new __parcel__URL__("shipmentIcon.6387e51f.svg").toString();